import { render, staticRenderFns } from "./FloatEmojiPicker.vue?vue&type=template&id=51e21cbc&scoped=true&"
import script from "./FloatEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./FloatEmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./FloatEmojiPicker.vue?vue&type=style&index=0&id=51e21cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e21cbc",
  null
  
)

export default component.exports